
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Renderer2, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ScrollPanel } from 'primeng/primeng';
import { StoreService } from '../store.service';
import './homelayout.component.css';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
@Component({
    selector: 'app-homelayout',
    templateUrl: './homelayout.component.html',
    //styleUrls: ['./homelayout.component.css'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('submenu', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class HomelayoutComponent implements AfterViewInit, OnDestroy {

    public menuInactiveDesktop: boolean;

    public menuActiveMobile: boolean;

    public profileActive: boolean;

    public topMenuActive: boolean;

    public topMenuLeaving: boolean;

    subscribedPlan: any = null;
    totalTrialPdf: any = 0;
    totalPaidPdf: any = 0;
    leftTrailDays: any = 0;
    leftPaidDays: any = 0;
    public companyName: String = "No company is connected, Connect a company from Switch Company menu";



    @ViewChild('scroller') public scrollerViewChild: ScrollPanel;

    documentClickListener: Function;

    menuClick: boolean;

    topMenuButtonClick: boolean;

    isCanceledNotExprired: boolean = false;


    constructor(private api: ApiService, private router: Router, public renderer: Renderer2, private ss: StoreService) {

        this.companyName = this.ss.fetchCompanyName();
        if (this.companyName == '' || this.companyName == null) {
            this.companyName = "No company is connected, Connect a company from Switch Company menu";
        }
        console.log('home' + this.companyName);

        this.getSubscribedPlan();
    }


    ngAfterViewInit() {

        this.getSubscribedPlan();
        setTimeout(() => { this.scrollerViewChild.moveBar(); }, 100);
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.isDesktop()) {
                if (!this.menuClick) {
                    this.menuActiveMobile = false;
                }

                if (!this.topMenuButtonClick) {
                    this.hideTopMenu();
                }
            }

            this.menuClick = false;
            this.topMenuButtonClick = false;
        });
    }

    toggleMenu(event: Event) {
        this.getSubscribedPlan();
        this.menuClick = true;
        if (this.isDesktop()) {
            this.menuInactiveDesktop = !this.menuInactiveDesktop;
            if (this.menuInactiveDesktop) {
                this.menuActiveMobile = false;
            }
        } else {
            this.menuActiveMobile = !this.menuActiveMobile;
            if (this.menuActiveMobile) {
                this.menuInactiveDesktop = false;
            }
        }

        if (this.topMenuActive) {
            this.hideTopMenu();
        }

        event.preventDefault();
    }

    toggleProfile(event: Event) {
        this.getSubscribedPlan();
        this.profileActive = !this.profileActive;
        event.preventDefault();
    }

    toggleTopMenu(event: Event) {
        this.getSubscribedPlan();
        this.topMenuButtonClick = true;
        this.menuActiveMobile = false;

        if (this.topMenuActive) {
            this.hideTopMenu();
        } else {
            this.topMenuActive = true;
        }

        event.preventDefault();
    }

    hideTopMenu() {

        this.getSubscribedPlan();
        this.topMenuLeaving = true;
        setTimeout(() => {
            this.topMenuActive = false;
            this.topMenuLeaving = false;
        }, 500);
    }

    onMenuClick() {

        this.getSubscribedPlan();
        this.menuClick = true;

        setTimeout(() => { this.scrollerViewChild.moveBar(); }, 500);
    }

    isDesktop() {
        this.getSubscribedPlan();
        return window.innerWidth > 1024;
    }

    onSearchClick() {
        this.getSubscribedPlan();
        this.topMenuButtonClick = true;
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

    getSubscribedPlan() {
        this.api.get('Plan/GetAccountSubscribedPlan', '').subscribe(
            (res: {}) => this.sucessGetSubscribedPlan(res),
            error => this.failedGetSubscribedPlan(<any>error));
    }

    sucessGetSubscribedPlan(res: any) {
        this.subscribedPlan = res.Data;
        this.leftTrailDays = this.subscribedPlan.LeftTrailDays;
        if (!this.subscribedPlan.IsPaidPlan) {
            this.getTotalTrialPdfUsed();
        }
        else {
            this.getTotalPaidPdfUsed();
        }

        if (this.subscribedPlan.ExpiringOn) {
            const expiryDate = new Date(this.subscribedPlan.ExpiringOn);
            const currentDate = new Date();

            const differenceInMs = expiryDate.getTime() - currentDate.getTime();
            const daysLeft = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

            if (daysLeft > 0) {
                this.leftPaidDays= daysLeft;
                console.log(`${daysLeft} day(s) left`);
            } else if (daysLeft === 0) {
                console.log('Plan expires today');
            } else {
                console.log('Plan has expired');
            }
        }

    }

    failedGetSubscribedPlan(res: any) {

    }


    getTotalTrialPdfUsed() {
        this.api.get('Plan/GetTotalTrialPdfUsed', '').subscribe(
            (res: {}) => this.sucessGetTotalTrialPdfUsed(res),
            error => this.failedGetTotalTrialPdfUsed(<any>error));
    }

    sucessGetTotalTrialPdfUsed(res: any) {
        if (res.Data != null) {

            const TrialPdf = this.subscribedPlan.TrialPdf;
            const TotalPaidUsedOnCurrentSubscription = res.Data.TotalPaidUsedOnCurrentSubscription
            this.totalTrialPdf = TrialPdf - TotalPaidUsedOnCurrentSubscription;


        }

        if (this.totalTrialPdf >= 0 && this.totalTrialPdf <= 20) {
            this.api.get('Plan/SendRemainingTrialPdfMail?RemainingTrialPDF=', this.totalTrialPdf).subscribe(
                (res: {}) => this.sentMailsuccessfully(res),
                error => this.errorInSendMail(<any>error));
        }
    }


    failedGetTotalTrialPdfUsed(res: any) {

    }

    getTotalPaidPdfUsed() {
        this.api.get('Plan/GetTotalPaidPdfUsed', '').subscribe(
            (res: {}) => this.sucessGetTotalPaidPdfUsed(res),
            error => this.failedGetTotalPaidPdfUsed(<any>error));
    }

    sucessGetTotalPaidPdfUsed(res: any) {
        if (res.Data != null) {
            // this.totalPaidPdf = this.subscribedPlan.TotalAllocatePDF - res.Data.TotalPaidUsed;
            const currentDate = new Date();
            const expiringOnDate = new Date(this.subscribedPlan.ExpiringOn); // Convert to Date

            console.log({ expiringOnDate, currentDate, diffGreat: expiringOnDate >= currentDate, small: expiringOnDate <= currentDate })
            // Comparison logic
            this.isCanceledNotExprired = this.subscribedPlan.IsCanceled;

            if (this.isCanceledNotExprired) this.totalPaidPdf = this.subscribedPlan.CurrentAllocatePDF - res.Data.TotalPaidUsedOnCurrentSubscription;
            else this.totalPaidPdf = this.subscribedPlan.CurrentAllocatePDF - res.Data.TotalPaidUsedOnCurrentSubscription;
        }

        if (this.totalPaidPdf >= 0 && this.totalPaidPdf <= 20) {
            this.api.get('Plan/SendRemainingTrialPdfMail?RemainingTrialPDF=', this.totalTrialPdf).subscribe(
                (res: {}) => this.sentMailsuccessfully(res),
                error => this.errorInSendMail(<any>error));
        }
    }

    failedGetTotalPaidPdfUsed(res: any) {

    }

    sentMailsuccessfully(res: any) {
        console.log("SuccessFully Sent Mail...")
    }
    errorInSendMail(error: any) {
        console.log("Error in sending mail " + error);
    }
}